import Container from "@mui/material/Container";

const Layout = (props: any) => {
    return (
        <div className="app-container">
            {props.children ? (
                <Container maxWidth="lg">
                    {props.children}
                </Container>
            ) : null}
        </div>
    );
};

export default Layout;
